import { TableCell } from "@material-ui/core";
import { memo } from "react";

const AccountTableCell = ({ align, id, data }) => (
  <TableCell
    align={align}
    key={id}
    style={{
      fontSize: "0.75rem",
    }}
  >
    {data}
  </TableCell>
);
export default memo(AccountTableCell);
